// What the map shares with the rest of the app, apart from the map itself (TripMap.tsx), whose code (MapLibre's
// with it) loads only once a map is first shown (load.tsx).

// How near counts as nearby (m): a selected place's dashed ring on the map, and what's nearby on its card.
export const NEARBY_M = 2000;

// How strongly what's dimmed shows: what the person, musts and friend filters don't pick, and what a
// search doesn't find. One dimmed look on the map, whatever dims it.
export const DIMMED = 0.3;

// What's over the map at each edge (px), which what it frames keeps clear of.
export interface Padding {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

// The map's land, Daylight's and Night's (style.ts draws it): what the map shows before anything is drawn on
// it, its code still loading included (load.tsx), so it never shows another colour first.
export const LAND = { light: "#f2ede4", dark: "#25221e" } as const;

// Where I am, from this device.
export interface Fix {
  lat: number;
  lng: number;
  accuracy?: number;
}
